export const TREASURY_PRIVATE_KEY = "ae6cc3e1049a8566c5e2e7c9778b381b2ad9458d3f00a44e33c920138e84e029";
export const TREASURY_PUBLIC_KEY = "0x6c5d8Ba1181a53d492138e7965dd1565759a8705";